import { createSlice } from '@reduxjs/toolkit'
import type { StreamsAnalysisResponse } from './apiTypes'

type Status = 'idle' | 'loading' | 'succeeded' | 'failed'

interface StreamAnalysisState {
  status: Status
  error: string | null
  dataByKey: Record<string, StreamsAnalysisResponse>
}

const initialState: StreamAnalysisState = {
  status: 'idle',
  error: null,
  dataByKey: {},
}

/**
 * Legacy Redux home for optional multi-stream analysis payloads.
 * Deep-dive charts use `POST /api/analysis` via Zustand + hooks instead.
 */
const streamAnalysisSlice = createSlice({
  name: 'streamAnalysis',
  initialState,
  reducers: {
    clearStreamAnalysis(state) {
      state.status = 'idle'
      state.error = null
      state.dataByKey = {}
    },
    setStreamAnalysisResult(state, action: { payload: { key: string; data: StreamsAnalysisResponse } }) {
      state.status = 'succeeded'
      state.error = null
      state.dataByKey[action.payload.key] = action.payload.data
    },
  },
})

export const { clearStreamAnalysis, setStreamAnalysisResult } = streamAnalysisSlice.actions
export default streamAnalysisSlice.reducer
